import handleBookaDemoClick from '../../constants/bookAdemoClick';
import './DataFlowController.css';

const DataFlowController = () => {
  return (
    <section className="data-flow-controller">
      <div className="data-visualizer">
        <div className="i-14">
          <img
            loading="lazy"
            src="/OverviewPage/AbandonedCartRecovery.webp"
            alt="AbandonedCartRecovery"
            title="AbandonedCartRecovery"
            className="HomePageHeroImage"
          />
        </div>
        <div className="data-visualizer-inner">
          <div className="abandoned-cart-recovery-parent">
            <h1 className="abandoned-cart-recovery">Abandoned Cart Recovery</h1>
            <div className="perfect-for-ecommerce">
              Perfect for ecommerce businesses looking to recover lost revenue.
            </div>
            <div className="button36">
              <a
                rel="noopener noreferrer"
                onClick={(e) =>
                  handleBookaDemoClick(
                    e,
                    'https://relevaad.zohobookings.eu/#/187906000000034054?utm_source=releva-website&utm_medium=website&utm_campaign=book-a-demo&utm_content=book-a-demo-button-SocialMediaPage'
                  )
                }
                target="_blank"
              >
                <div className="button-name28">Book a demo</div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DataFlowController;
